// third party
import * as yup from 'yup';
import { format, isDate, isValid } from 'date-fns'; // isAfter

export const RECURRENCE_TYPES = ['none', 'daily', 'weekly', 'biweekly', 'monthly', 'quarterly', 'biannual', 'yearly'];
export const EXPIRATION_TYPES = ['none', 'byExpTime', 'byRecCount'];

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            recurrenceType: yup
                .string()
                .oneOf(RECURRENCE_TYPES, intl.formatMessage({ id: 'ui-comp-formvalidation-recurrencetype-unexpectedvalue' }))
                .nullable(),
            weekDays: yup
                .array()
                .of(yup.number())
                .when('recurrenceType', {
                    is: 'weekly',
                    then: (schema) =>
                        schema
                            .min(1, intl.formatMessage({ id: 'ui-comp-formvalidation-weekdays-atleastone' }))
                            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-weekdays-required' }))
                })
                .nullable(),
            monthDays: yup.array().of(yup.number()).nullable(),
            helperFieldStartTime: yup
                .date()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-starttime-invalid' }))
                .when('recurrenceType', {
                    is: (recurrenceType) => ['daily', 'weekly']?.includes(recurrenceType),
                    then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-starttime-required' }))
                })
                .nullable(),
            helperFieldEndTime: yup
                .date()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-endtime-invalid' }))
                .when('helperFieldStartTime', (helperFieldStartTime, schema) => {
                    if (isDate(helperFieldStartTime) && isValid(helperFieldStartTime)) {
                        return schema.min(
                            helperFieldStartTime,
                            intl.formatMessage({
                                id: 'ui-comp-formvalidation-endtime-min',
                                values: { minValue: format(helperFieldStartTime, 'HH:mm') }
                            })
                        );
                    }

                    return schema;
                })
                .nullable(),
            expirationType: yup
                .string()
                .oneOf(EXPIRATION_TYPES, intl.formatMessage({ id: 'ui-comp-formvalidation-expirationtype-unexpectedvalue' }))
                .nullable(),
            expiresAtRecCount: yup
                .number()
                .when('expirationType', {
                    is: 'byRecCount',
                    then: (schema) =>
                        schema
                            .positive(intl.formatMessage({ id: 'ui-comp-formvalidation-expiresatreccount-positive' }))
                            .max(999, intl.formatMessage({ id: 'ui-comp-formvalidation-expiresatreccount-max', values: { maxValue: 999 } }))
                            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-expiresatreccount-required' }))
                })
                .nullable(),
            expiresAtTime: yup
                .date()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-expiresattime-invalid' }))
                .when('expirationType', {
                    is: 'byExpTime',
                    then: (schema) => schema.required(intl.formatMessage({ id: 'ui-comp-formvalidation-expiresattime-required' }))
                })
                .nullable()
        })
        // .test({
        //     name: 'validateRecExpTimeByWorkOrderEndDate',
        //     message: intl.formatMessage({ id: 'ui-comp-formvalidation-recursettings-expdateoutofrange' }),
        //     test: (recurSettings, context) =>
        //         !(
        //             'estimatedEndDate' in (context?.parent?.execSettings || {}) &&
        //             'expiresAtTime' in (recurSettings || {}) &&
        //             isDate(context?.parent?.execSettings?.estimatedEndDate) &&
        //             isValid(context?.parent?.execSettings?.estimatedEndDate) &&
        //             isDate(recurSettings?.expiresAtTime) &&
        //             isValid(recurSettings?.expiresAtTime) &&
        //             isAfter(context?.parent?.execSettings?.estimatedEndDate, recurSettings?.expiresAtTime)
        //         )
        // })
        .nullable();

export default validationSchema;
